const C = {
  name: "Webcam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 11.25C12.69 11.25 13.25 10.69 13.25 10C13.25 9.31 12.69 8.75 12 8.75C11.31 8.75 10.75 9.31 10.75 10C10.75 10.69 11.31 11.25 12 11.25Z" fill="currentColor"/>
<path d="M12 0C6.47772 0 2 4.47772 2 10C2 15.5223 6.47772 20 12 20C17.5223 20 22 15.5223 22 10C22 4.47772 17.5223 0 12 0ZM4.06192 9C4.55413 5.05411 7.92094 2 12 2C16.0791 2 19.4459 5.05411 19.9381 9H16.9001C16.437 6.71722 14.4198 5 12 5C9.5802 5 7.56296 6.71722 7.09993 9H4.06192ZM16.9001 11H19.9381C19.4459 14.9459 16.0791 18 12 18C7.92094 18 4.55413 14.9459 4.06192 11H7.09993C7.56296 13.2828 9.5802 15 12 15C14.4198 15 16.437 13.2828 16.9001 11ZM12 7C13.6577 7 15 8.34229 15 10C15 11.6577 13.6577 13 12 13C10.3423 13 9 11.6577 9 10C9 8.34229 10.3423 7 12 7Z" fill="currentColor"/>
<path d="M7 22V24H17V22H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Webcam
};
